import { Bell } from "lucide-react";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { useNotifications } from "../NotificationProvider";
import { NotificationPanel } from "./NotificationPanel";

export function NotificationBell() {
  const { t } = useTranslation();
  const { unreadCount, isOpen, togglePanel } = useNotifications();

  return (
    <div className="relative">
      <button
        id="notification-bell"
        type="button"
        onClick={togglePanel}
        aria-label={t.header.notifications}
        aria-expanded={isOpen}
        className={`rhythm-icon-btn relative ${isOpen ? "text-primary" : ""}`}
      >
        <Bell size={20} strokeWidth={1.75} />
        {unreadCount > 0 && (
          <span className="absolute -right-0.5 -top-0.5 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-accent px-1 text-[10px] font-semibold text-accent-foreground">
            {unreadCount > 9 ? "9+" : unreadCount}
          </span>
        )}
      </button>
      <NotificationPanel />
    </div>
  );
}
